export default { Loading: 'โหลด' };
